import { ContactDataType } from '@oy/types';
import { getTranslation } from 'src/utilities/translator';
import { AdditionalDocument, ContactSummary, SubStepValue } from './model';

export const MAX_TRANSFER_AMOUNT = 20000000000;
export const MIN_TRANSFER_AMOUNT = 200000;

export const DEFAULT_SUB_STEP_VALUE: SubStepValue = {
  first: 2,
  second: 5,
};

export const DEFAULT_ADDTIONAL_DOCUMENT_STATE: AdditionalDocument[] = [];
export const DEFAULT_INVOICE_STATE: AdditionalDocument | null = null;
export const MB = 10 ** 6;
export const MAXIMUM_ATTEMPTS = 5;
export const ALLOWED_FILE_TYPE =
  'application/pdf, image/jpeg, .xlsx, image/png, .docx';

export const IDENTIFICATION_TYPE_OPTIONS = [
  {
    label: 'common_passport',
    value: 'passport',
  },
  {
    label: 'common_ktp',
    value: 'nric',
  },
  {
    label: 'common_unspecified',
    value: 'unspecified',
  },
];

export const DEFAULT_CONTACT_VALUE = {
  address: '',
  name: '',
  country_code: '',
  gender: '',
  date_of_birth: '',
  id_type: '',
  id_number: '',
  business_reg_number: '',
  country_of_incorporation: '',
  country_of_operation: '',
  date_of_incorporation: '',
  website: '',
  email: '',
  mobile_number: '',
  bank_name: '',
  bank_account_name: '',
  bank_account_number: '',
  transfer_purpose: '',
  source_of_fund: '',
  contact_type: ContactDataType.PERSONAL,
};

export const DEFAULT_PAYMENT_DETAIL = {
  source_amount: '',
  transfer_fee: '',
  amount_converted: '',
  fx_rate: '',
  created_time: '',
  last_updated: '',
  converted_amount: '',
  destination_amount: '',
  destination_currency_code: '',
  created_by: '',
  tx_status: '',
  attachment_urls: [],
};

export const DATE_FORMAT_WITH_TIME = 'DD MMM YYYY HH:mm';
export const DATE_FORMAT_WITH_TIME_LIST = 'DD/MM/YYYY, HH:mm';
export const DATE_FORMAT_WITH_TIME_RECEIPT = 'DD MMMM YYYY, HH:mm';
export const DATE_FORMAT_YEAR_TO_DAY = 'yyyy-MM-DD';
export const DATE_FORMAT_YEAR_TO_DAY_DATEPICKER = 'yyyy-MM-dd';
export const DATE_FORMAT_DAY_TO_YEAR = 'DD/MM/yyyy';
export const DATE_FORMAT_DAY_TO_YEAR_DATEPICKER = 'dd MMM yyyy';

export const ADDITIONAL_DOCUMENT_INFO = [
  {
    documentType: 'internationalTransfer_creationStep_senderData',
    child: [
      'internationalTransfer_senderData_identity',
      'internationalTransfer_senderData_contactDetail',
    ],
  },
  {
    documentType: 'internationalTransfer_creationStep_recipientData',
    child: [
      'internationalTransfer_recipientData_identity',
      'internationalTransfer_recipientData_contactDetail',
      'internationalTransfer_contactForm_paymentInformation',
    ],
  },
  {
    documentType: 'common_supportingData',
    child: [
      'bulkDisbursement_createUpload_sourceOfFund_option_label',
      'common_transferReason',
      'internationalTransfer_supportingDocument_example',
    ],
  },
];

export const COACHMARK_SENDER_LIST: ContactSummary[] = [
  {
    country_code: 'ID',
    email: 'aiden.lucasss@gmail.com',
    last_updated: '',
    mobile_number: '',
    name: 'Aiden Lucas',
    partner_contact_ref: 'coachmark_sender_1',
    type: ContactDataType.PERSONAL,
  },
  {
    country_code: 'ID',
    email: 'k.johnsson@gmail.com',
    last_updated: '',
    mobile_number: '+6281239470629',
    name: 'PT Sejahtera Lunaria Annua',
    partner_contact_ref: 'coachmark_sender_2',
    type: ContactDataType.BUSINESS,
  },
  {
    country_code: 'ID',
    email: 'marco.jsmith@gmail.com',
    last_updated: '',
    mobile_number: '',
    name: 'PT Kerja Sukses Bersama',
    partner_contact_ref: 'coachmark_sender_3',
    type: ContactDataType.BUSINESS,
  },
  {
    country_code: 'ID',
    email: 'tian.christy@gmail.com',
    last_updated: '',
    mobile_number: '+6281234567890',
    name: 'Tiana',
    partner_contact_ref: 'coachmark_sender_4',
    type: ContactDataType.PERSONAL,
  },
];

export const COACHMARK_RECIPIENT_LIST: ContactSummary[] = [
  {
    country_code: 'SG',
    email: '',
    last_updated: '',
    mobile_number: '',
    name: 'Albert Harrison',
    partner_contact_ref: 'coachmark_recipient_1',
    type: ContactDataType.PERSONAL,
  },
  {
    country_code: 'SG',
    email: '',
    last_updated: '',
    mobile_number: '+6581239470629',
    name: 'Jardine Strategic Holdings',
    partner_contact_ref: 'coachmark_recipient_2',
    type: ContactDataType.BUSINESS,
  },
  {
    country_code: 'SG',
    email: 'shar.oliver@gmail.com',
    last_updated: '',
    mobile_number: '+6581234567890',
    name: 'Sharon Oliver',
    partner_contact_ref: 'coachmark_recipient_3',
    type: ContactDataType.PERSONAL,
  },
  {
    country_code: 'SG',
    email: 'phoebe.wil@singtel.com',
    last_updated: '',
    mobile_number: '',
    name: 'Singapore Telecommunications',
    partner_contact_ref: 'coachmark_recipient_4',
    type: ContactDataType.BUSINESS,
  },
];

// From this point onward, temporary hardcode, BE is under development
export const SOURCE_OF_FUND_OPTIONS = [
  'BI',
  'CP',
  'DI',
  'EI',
  'IG',
  'IP',
  'II',
  'LD',
  'LO',
  'LW',
  'RI',
  'SC',
  'SI',
  'SP',
  'SR',
];

export const TRANSFER_REASON_OPTIONS = [
  'BP',
  'EO',
  'EF',
  'EP',
  'FT',
  'BE',
  'LE',
  'GD',
  'IC',
  'IS',
  'LD',
  'LP',
  'PD',
  'PN',
  'PS',
  'PF',
  'PR',
  'SF',
  'SS',
  'SA',
  'TS',
  'TE',
];

export const getIdOptions = () => {
  return IDENTIFICATION_TYPE_OPTIONS.map(id => {
    return {
      label: getTranslation(id.label),
      value: id.value,
    };
  });
};

export const getIdLabel = (idType: string) => {
  return (
    IDENTIFICATION_TYPE_OPTIONS.find(({ value }) => value === idType)?.label ??
    'common_unspecified'
  );
};

export const getSoFLabel = (sof: string) => {
  return sof ? getTranslation('internationalTransfer_SoF_' + sof) : '';
};

export const getTRLabel = (tr: string, forceEng = false) => {
  return tr
    ? getTranslation('internationalTransfer_TR_' + tr, forceEng ? 'en' : '')
    : '';
};

export const CURRENCY_DESTINATION_OPTIONS = [
  {
    label: 'Singapore Dollar',
    value: 'SGD',
  },
  {
    label: 'United States Dollar',
    value: 'USD',
  },
];

export const COUNTRY_DESTINATION_OPTIONS = [
  {
    label: 'Singapore',
    value: 'SG',
  },
];

export const CURRENCY_SOURCE_OPTIONS = [
  {
    label: 'ID',
    value: 'IDR',
  },
];

export const LIST_ALL_CURRENCY = CURRENCY_DESTINATION_OPTIONS.concat([
  {
    label: 'Indonesian Rupiah',
    value: 'IDR',
  },
]);

export const LIST_ALL_COUNTRY = [
  {
    label: 'Indonesia',
    value: 'ID',
  },
  {
    label: 'Singapore',
    value: 'SG',
  },
];

type ListBank = {
  bank_country: string;
  bank_name: string;
  ts_bank_code: string;
  swift_bic_code: string | null;
  bank_code: string | null;
  zengin_code: string | null;
  cnaps_code: string | null;
  ifsc_code: string | null;
};

type ListBankDestination = {
  [key: string]: ListBank[];
};

const LIST_BANK_DESTINATION: ListBankDestination = {
  SG: [
    {
      bank_country: 'SG',
      bank_name: 'Svenska Handelsbanken, Singapore Branch',
      ts_bank_code: 'TSSG0043',
      swift_bic_code: 'HANDSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Bank of India',
      ts_bank_code: 'TSSG0005',
      swift_bic_code: 'BKIDSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Bangkok Bank Public Company Ltd',
      ts_bank_code: 'TSSG0002',
      swift_bic_code: 'BKKBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Oversea-Chinese Banking Corporation Limited [OCBC Bank]',
      ts_bank_code: 'TSSG0034',
      swift_bic_code: 'OCBCSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'HSBC Bank (Singapore) Ltd - Personal',
      ts_bank_code: 'TSSG0019',
      swift_bic_code: 'HSBCSGS2',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Nordea Bank Abp Singapore Branch',
      ts_bank_code: 'TSSG0033',
      swift_bic_code: 'NDEASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name:
        'The Hongkong & Shanghai Banking Corporation Limited [HSBC] - Corporate',
      ts_bank_code: 'TSSG0045',
      swift_bic_code: 'HSBCSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'DnB Bank ASA, Singapore Branch',
      ts_bank_code: 'TSSG0016',
      swift_bic_code: 'DNBASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Standard Chartered Bank (S) Ltd',
      ts_bank_code: 'TSSG0040',
      swift_bic_code: 'SCBLSG22',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'DBS Bank Ltd / POSBank',
      ts_bank_code: 'TSSG0014',
      swift_bic_code: 'DBSSSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Indian Overseas Bank [IOB], Singapore Branch',
      ts_bank_code: 'TSSG0022',
      swift_bic_code: 'IOBASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Sumitomo Mitsui Banking Corporation, Singapore Branch',
      ts_bank_code: 'TSSG0042',
      swift_bic_code: 'SMBCSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'State Bank of India',
      ts_bank_code: 'TSSG0041',
      swift_bic_code: 'SBINSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Bank of America, N.A. Singapore',
      ts_bank_code: 'TSSG0003',
      swift_bic_code: 'BOFASG2X',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'The Bank of East Asia Ltd',
      ts_bank_code: 'TSSG0044',
      swift_bic_code: 'BEASSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'RHB Bank Berhad',
      ts_bank_code: 'TSSG0036',
      swift_bic_code: 'RHBBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Trust Bank Singapore Limited',
      ts_bank_code: 'TSSG0049',
      swift_bic_code: 'TRBUSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'First Commerical Bank, Ltd.',
      ts_bank_code: 'TSSG0017',
      swift_bic_code: 'FCBKSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'MUFG Bank, Ltd. Singapore Branch',
      ts_bank_code: 'TSSG0031',
      swift_bic_code: 'BOTKSGSX',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'JPMorgan Chase Bank, N.A.',
      ts_bank_code: 'TSSG0025',
      swift_bic_code: 'CHASSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name:
        'Skandinaviska Enskilda Banken AB (publ) [SEB], Singapore Branch',
      ts_bank_code: 'TSSG0037',
      swift_bic_code: 'ESSESGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name:
        'Industrial & Commercial Bank of China [ICBC], Singapore Branch',
      ts_bank_code: 'TSSG0023',
      swift_bic_code: 'ICBKSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Maybank Singapore Limited',
      ts_bank_code: 'TSSG0029',
      swift_bic_code: 'MBBESGS2',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'P.T. Bank Negara Indonesia (Persero) Tbk',
      ts_bank_code: 'TSSG0035',
      swift_bic_code: 'BNINSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Crédit Agricole CIB, Singapore Branch',
      ts_bank_code: 'TSSG0012',
      swift_bic_code: 'CRLYSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'ICICI Bank Limited, Singapore Branch',
      ts_bank_code: 'TSSG0020',
      swift_bic_code: 'ICICSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Deutsche Bank AG, Singapore Branch',
      ts_bank_code: 'TSSG0015',
      swift_bic_code: 'DEUTSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'UCO Bank',
      ts_bank_code: 'TSSG0047',
      swift_bic_code: 'UCBASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Australia & New Zealand Banking Group Ltd [ANZ]',
      ts_bank_code: 'TSSG0001',
      swift_bic_code: 'ANZBSGSX',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Landesbank Baden-Wuerttemberg [LBBW], Singapore Branch',
      ts_bank_code: 'TSSG0027',
      swift_bic_code: 'SOLASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'HL Bank, Singapore',
      ts_bank_code: 'TSSG0018',
      swift_bic_code: 'HLBBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Intesa Sanpaolo S.P.A. Singapore Branch',
      ts_bank_code: 'TSSG0024',
      swift_bic_code: 'BCITSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'CIMB Bank Berhad, Singapore Branch',
      ts_bank_code: 'TSSG0007',
      swift_bic_code: 'CIBBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'KEB HANA Bank Singapore Branch',
      ts_bank_code: 'TSSG0026',
      swift_bic_code: 'KOEXSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'National Australia Bank, Singapore Branch',
      ts_bank_code: 'TSSG0032',
      swift_bic_code: 'NATASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'UBS AG Singapore Branch',
      ts_bank_code: 'TSSG0046',
      swift_bic_code: 'UBSWSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Societe Generale, Singapore Branch',
      ts_bank_code: 'TSSG0038',
      swift_bic_code: 'SOGESGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Commerzbank AG, Singapore Branch',
      ts_bank_code: 'TSSG0011',
      swift_bic_code: 'COBASGSX',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Citibank Singapore Limited',
      ts_bank_code: 'TSSG0009',
      swift_bic_code: 'CITISGSL',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Bank of China Limited',
      ts_bank_code: 'TSSG0004',
      swift_bic_code: 'BKCHSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'United Overseas Bank Limited [UOB]',
      ts_bank_code: 'TSSG0048',
      swift_bic_code: 'UOVBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Citibank,N.A. Singapore Branch',
      ts_bank_code: 'TSSG0008',
      swift_bic_code: 'CITISGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Mizuho Bank, Ltd. Singapore Branch',
      ts_bank_code: 'TSSG0030',
      swift_bic_code: 'MHCBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Indian Bank, Singapore Branch',
      ts_bank_code: 'TSSG0021',
      swift_bic_code: 'IDIBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'Citibank Singapore Ltd (Global Consumer Banking Unit)',
      ts_bank_code: 'TSSG0010',
      swift_bic_code: 'CITISGSGGCB',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'BNP Paribas - Singapore Branch',
      ts_bank_code: 'TSSG0006',
      swift_bic_code: 'BNPASGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'SG',
      bank_name: 'CTBC Bank Co., Ltd., Singapore Branch',
      ts_bank_code: 'TSSG0013',
      swift_bic_code: 'CTCBSGSG',
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
  ],
  HK: [
    {
      bank_country: 'HK',
      bank_name: '064 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0064',
      swift_bic_code: null,
      bank_code: '064',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '263 Cathay Bank',
      ts_bank_code: 'TSHK0263',
      swift_bic_code: null,
      bank_code: '263',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '394 Qatar National Bank (Q.P.S.C.)',
      ts_bank_code: 'TSHK0394',
      swift_bic_code: null,
      bank_code: '394',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '151 Westpac Banking Corporation',
      ts_bank_code: 'TSHK0151',
      swift_bic_code: null,
      bank_code: '151',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '188 The Hachijuni Bank, Ltd. Hong Kong Branch',
      ts_bank_code: 'TSHK0188',
      swift_bic_code: null,
      bank_code: '188',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '060 National Bank of Pakistan Hong Kong',
      ts_bank_code: 'TSHK0060',
      swift_bic_code: null,
      bank_code: '060',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '256 Allahabad Bank',
      ts_bank_code: 'TSHK0256',
      swift_bic_code: null,
      bank_code: '256',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '251 ICICI Bank Ltd',
      ts_bank_code: 'TSHK0251',
      swift_bic_code: null,
      bank_code: '251',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '391 Fusion Bank Limited',
      ts_bank_code: 'TSHK0391',
      swift_bic_code: null,
      bank_code: '391',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '206 Chang Hwa Commercial Bank Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0206',
      swift_bic_code: null,
      bank_code: '206',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name:
        '234 Banca Monte Dei Paschi Di Siena S.P.A. - Hong Kong Branch',
      ts_bank_code: 'TSHK0234',
      swift_bic_code: null,
      bank_code: '234',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '309 Union Bancaire Privée, UBP SA',
      ts_bank_code: 'TSHK0309',
      swift_bic_code: null,
      bank_code: '309',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '241 Bank SinoPac',
      ts_bank_code: 'TSHK0241',
      swift_bic_code: null,
      bank_code: '241',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '016 DBS Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0016',
      swift_bic_code: null,
      bank_code: '016',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '076 The Bank of Nova Scotia',
      ts_bank_code: 'TSHK0076',
      swift_bic_code: null,
      bank_code: '076',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '063 Maybank Hong Kong',
      ts_bank_code: 'TSHK0063',
      swift_bic_code: null,
      bank_code: '063',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '031 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0031',
      swift_bic_code: null,
      bank_code: '031',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '072 Industrial and Commercial Bank Of China (Asia) Limited',
      ts_bank_code: 'TSHK0072',
      swift_bic_code: null,
      bank_code: '072',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '360 Natwest Markets N.V. Hong Kong Branch',
      ts_bank_code: 'TSHK0360',
      swift_bic_code: null,
      bank_code: '360',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '150 National Australia Bank Limited',
      ts_bank_code: 'TSHK0150',
      swift_bic_code: null,
      bank_code: '150',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '383 China Zheshang Bank Co., Ltd. (Hong Kong Branch)',
      ts_bank_code: 'TSHK0383',
      swift_bic_code: null,
      bank_code: '383',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '138 Mitsubishi UFJ Trust and Banking Corporation',
      ts_bank_code: 'TSHK0138',
      swift_bic_code: null,
      bank_code: '138',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '006 Citibank N.A.',
      ts_bank_code: 'TSHK0006',
      swift_bic_code: null,
      bank_code: '006',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '043 Nanyang Commercial Bank Limited',
      ts_bank_code: 'TSHK0043',
      swift_bic_code: null,
      bank_code: '043',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '003 Standard Chartered Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0003',
      swift_bic_code: null,
      bank_code: '003',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '139 The Bank of New York Mellon, Hong Kong Branch',
      ts_bank_code: 'TSHK0139',
      swift_bic_code: null,
      bank_code: '139',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name:
        '337 Taiwan Shin Kong Commercial Bank Co., Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0337',
      swift_bic_code: null,
      bank_code: '337',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '012 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0012',
      swift_bic_code: null,
      bank_code: '012',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '260 Far Eastern International Bank, Hong Kong Branch',
      ts_bank_code: 'TSHK0260',
      swift_bic_code: null,
      bank_code: '260',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '009 China Construction Bank (Asia) Corporation Limited',
      ts_bank_code: 'TSHK0009',
      swift_bic_code: null,
      bank_code: '009',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '199 The Shiga Bank, Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0199',
      swift_bic_code: null,
      bank_code: '199',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '186 The Shizuoka Bank, Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0186',
      swift_bic_code: null,
      bank_code: '186',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '056 BNP Paribas',
      ts_bank_code: 'TSHK0056',
      swift_bic_code: null,
      bank_code: '056',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '274 O-Bank Co., Ltd',
      ts_bank_code: 'TSHK0274',
      swift_bic_code: null,
      bank_code: '274',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '050 Indian Overseas Bank, Hong Kong',
      ts_bank_code: 'TSHK0050',
      swift_bic_code: null,
      bank_code: '050',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '152 Australia and New Zealand Banking Group Ltd',
      ts_bank_code: 'TSHK0152',
      swift_bic_code: null,
      bank_code: '152',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '384 Morgan Stanley Bank Asia Limited',
      ts_bank_code: 'TSHK0384',
      swift_bic_code: null,
      bank_code: '384',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '378 Yuanta Commercial Bank Co., Ltd. Hong Kong',
      ts_bank_code: 'TSHK0378',
      swift_bic_code: null,
      bank_code: '378',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '237 EFG Bank AG',
      ts_bank_code: 'TSHK0237',
      swift_bic_code: null,
      bank_code: '237',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '008 Natwest Markets plc Hong Kong Branch',
      ts_bank_code: 'TSHK0008',
      swift_bic_code: null,
      bank_code: '008',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '153 Commonwealth Bank of Australia',
      ts_bank_code: 'TSHK0153',
      swift_bic_code: null,
      bank_code: '153',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '097 Commerzbank AG',
      ts_bank_code: 'TSHK0097',
      swift_bic_code: null,
      bank_code: '097',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '372 Bank Of Shanghai (Hong Kong) Limited',
      ts_bank_code: 'TSHK0372',
      swift_bic_code: null,
      bank_code: '372',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '061 Tai Sang Bank Limited',
      ts_bank_code: 'TSHK0061',
      swift_bic_code: null,
      bank_code: '061',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '044 OCBC Wing Hang Bank Limited',
      ts_bank_code: 'TSHK0044',
      swift_bic_code: null,
      bank_code: '044',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '106 HSBC Bank Usa, National Association',
      ts_bank_code: 'TSHK0106',
      swift_bic_code: null,
      bank_code: '106',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '029 Industrial and Commercial Bank of China (Asia) Limited',
      ts_bank_code: 'TSHK0029',
      swift_bic_code: null,
      bank_code: '029',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '230 Taiwan Business Bank Hong Kong Branch',
      ts_bank_code: 'TSHK0230',
      swift_bic_code: null,
      bank_code: '230',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '261 Axis Bank Limited',
      ts_bank_code: 'TSHK0261',
      swift_bic_code: null,
      bank_code: '261',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '239 Taipei Fubon Commercial Bank Co., Ltd. Hong Kong Branch',
      ts_bank_code: 'TSHK0239',
      swift_bic_code: null,
      bank_code: '239',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '007 JPMorgan Chase Bank, N.A., Hong Kong Branch',
      ts_bank_code: 'TSHK0007',
      swift_bic_code: null,
      bank_code: '007',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '047 MUFG Bank, Ltd.',
      ts_bank_code: 'TSHK0047',
      swift_bic_code: null,
      bank_code: '047',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '046 KEB Hana Bank',
      ts_bank_code: 'TSHK0046',
      swift_bic_code: null,
      bank_code: '046',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '379 Mashreqbank PSC., Hong Kong Branch',
      ts_bank_code: 'TSHK0379',
      swift_bic_code: null,
      bank_code: '379',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '058 Bank of India',
      ts_bank_code: 'TSHK0058',
      swift_bic_code: null,
      bank_code: '058',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '381 Kookmin Bank, Hong Kong Branch',
      ts_bank_code: 'TSHK0381',
      swift_bic_code: null,
      bank_code: '381',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '041 Chong Hing Bank Limited',
      ts_bank_code: 'TSHK0041',
      swift_bic_code: null,
      bank_code: '041',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '278 Bank J. Safra Sarasin Ltd, Hong Kong Branch',
      ts_bank_code: 'TSHK0278',
      swift_bic_code: null,
      bank_code: '278',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '267 Banco Santander S.A. Hong Kong Branch',
      ts_bank_code: 'TSHK0267',
      swift_bic_code: null,
      bank_code: '267',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '221 China Construction Bank Corporation',
      ts_bank_code: 'TSHK0221',
      swift_bic_code: null,
      bank_code: '221',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '359 China Guangfa Bank Co.,Ltd Hong Kong Branch',
      ts_bank_code: 'TSHK0359',
      swift_bic_code: null,
      bank_code: '359',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '030 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0030',
      swift_bic_code: null,
      bank_code: '030',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '205 Coutts & Co Ltd',
      ts_bank_code: 'TSHK0205',
      swift_bic_code: null,
      bank_code: '205',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '054 Deutsche Bank AG',
      ts_bank_code: 'TSHK0054',
      swift_bic_code: null,
      bank_code: '054',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '165 Svenska Handelsbanken Hong Kong Branch',
      ts_bank_code: 'TSHK0165',
      swift_bic_code: null,
      bank_code: '165',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '243 E.SUN Commercial Bank Ltd, Hong Kong Branch',
      ts_bank_code: 'TSHK0243',
      swift_bic_code: null,
      bank_code: '243',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '092 Canadian Imperial Bank of Commerce',
      ts_bank_code: 'TSHK0092',
      swift_bic_code: null,
      bank_code: '092',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '250 Citibank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0250',
      swift_bic_code: null,
      bank_code: '250',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '248 Hong Leong Bank Berhad Hong Kong Branch',
      ts_bank_code: 'TSHK0248',
      swift_bic_code: null,
      bank_code: '248',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '033 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0033',
      swift_bic_code: null,
      bank_code: '033',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '214 Industrial and Commercial Bank of China Limited',
      ts_bank_code: 'TSHK0214',
      swift_bic_code: null,
      bank_code: '214',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '395 Airstar Bank Limited',
      ts_bank_code: 'TSHK0395',
      swift_bic_code: null,
      bank_code: '395',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '220 State Street Bank and Trust Company, Hong Kong Branch',
      ts_bank_code: 'TSHK0220',
      swift_bic_code: null,
      bank_code: '220',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '080 Royal Bank of Canada',
      ts_bank_code: 'TSHK0080',
      swift_bic_code: null,
      bank_code: '080',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '390 WeLab Bank Limited',
      ts_bank_code: 'TSHK0390',
      swift_bic_code: null,
      bank_code: '390',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '038 Tai Yau Bank Limited',
      ts_bank_code: 'TSHK0038',
      swift_bic_code: null,
      bank_code: '038',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '374 CIMB Bank Berhad Hong Kong Branch',
      ts_bank_code: 'TSHK0374',
      swift_bic_code: null,
      bank_code: '374',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '258 East West Bank',
      ts_bank_code: 'TSHK0258',
      swift_bic_code: null,
      bank_code: '258',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '055 Bank of America, National Association',
      ts_bank_code: 'TSHK0055',
      swift_bic_code: null,
      bank_code: '055',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '210 Natixis',
      ts_bank_code: 'TSHK0210',
      swift_bic_code: null,
      bank_code: '210',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '273 Shinhan Bank, Hong Kong Branch',
      ts_bank_code: 'TSHK0273',
      swift_bic_code: null,
      bank_code: '273',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '024 Hang Seng Bank Limited',
      ts_bank_code: 'TSHK0024',
      swift_bic_code: null,
      bank_code: '024',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '392 Ping An OneConnect Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0392',
      swift_bic_code: null,
      bank_code: '392',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '027 Bank of Communications Co., Ltd. Hong Kong Branch',
      ts_bank_code: 'TSHK0027',
      swift_bic_code: null,
      bank_code: '027',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '025 Shanghai Commercial Bank Limited',
      ts_bank_code: 'TSHK0025',
      swift_bic_code: null,
      bank_code: '025',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '086 Bank of Montreal',
      ts_bank_code: 'TSHK0086',
      swift_bic_code: null,
      bank_code: '086',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '276 China Development Bank Hong Kong Branch',
      ts_bank_code: 'TSHK0276',
      swift_bic_code: null,
      bank_code: '276',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '262 Canara Bank Hong Kong Branch',
      ts_bank_code: 'TSHK0262',
      swift_bic_code: null,
      bank_code: '262',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '320 Bank Julius Baer & Co. Ltd.',
      ts_bank_code: 'TSHK0320',
      swift_bic_code: null,
      bank_code: '320',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '118 Woori Bank, Hong Kong',
      ts_bank_code: 'TSHK0118',
      swift_bic_code: null,
      bank_code: '118',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '081 Societe Generale, Hong Kong Branch',
      ts_bank_code: 'TSHK0081',
      swift_bic_code: null,
      bank_code: '081',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '342 LGT Bank AG, Hong Kong Branch',
      ts_bank_code: 'TSHK0342',
      swift_bic_code: null,
      bank_code: '342',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '164 Unicredit Bank AG Hong Kong Branch',
      ts_bank_code: 'TSHK0164',
      swift_bic_code: null,
      bank_code: '164',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '019 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0019',
      swift_bic_code: null,
      bank_code: '019',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '353 China Minsheng Banking Corp., Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0353',
      swift_bic_code: null,
      bank_code: '353',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '119 Philippine National Bank',
      ts_bank_code: 'TSHK0119',
      swift_bic_code: null,
      bank_code: '119',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '103 UBS AG Hong Kong Branch',
      ts_bank_code: 'TSHK0103',
      swift_bic_code: null,
      bank_code: '103',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '109 Mizuho Bank, Ltd. Hong Kong Branch',
      ts_bank_code: 'TSHK0109',
      swift_bic_code: null,
      bank_code: '109',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '020 CMB Wing Lung Bank Limited',
      ts_bank_code: 'TSHK0020',
      swift_bic_code: null,
      bank_code: '020',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '371 Sumitomo Mitsui Trust Bank, Limited',
      ts_bank_code: 'TSHK0371',
      swift_bic_code: null,
      bank_code: '371',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '316 Skandinaviska Enskilda Banken AB',
      ts_bank_code: 'TSHK0316',
      swift_bic_code: null,
      bank_code: '316',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '222 Agricultural Bank of China Limited Hong Kong Branch',
      ts_bank_code: 'TSHK0222',
      swift_bic_code: null,
      bank_code: '222',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '357 Pictet & Cie (Europe) S.A. Hong Kong Branch',
      ts_bank_code: 'TSHK0357',
      swift_bic_code: null,
      bank_code: '357',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '045 UCO Bank',
      ts_bank_code: 'TSHK0045',
      swift_bic_code: null,
      bank_code: '045',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '271 Industrial Bank of Korea, Hong Kong Branch',
      ts_bank_code: 'TSHK0271',
      swift_bic_code: null,
      bank_code: '271',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '377 Industrial Bank Co., Ltd. Hong Kong Branch',
      ts_bank_code: 'TSHK0377',
      swift_bic_code: null,
      bank_code: '377',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '238 China Merchants Bank, Hong Kong Branch',
      ts_bank_code: 'TSHK0238',
      swift_bic_code: null,
      bank_code: '238',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '254 Melli Bank plc',
      ts_bank_code: 'TSHK0254',
      swift_bic_code: null,
      bank_code: '254',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '266 Punjab National Bank',
      ts_bank_code: 'TSHK0266',
      swift_bic_code: null,
      bank_code: '266',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '339 CA Indosuez (Switzerland) SA, Hong Kong Branch',
      ts_bank_code: 'TSHK0339',
      swift_bic_code: null,
      bank_code: '339',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '227 Erste Group Bank AG',
      ts_bank_code: 'TSHK0227',
      swift_bic_code: null,
      bank_code: '227',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '036 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0036',
      swift_bic_code: null,
      bank_code: '036',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '235 HSBC Private Bank (Suisse) Sa',
      ts_bank_code: 'TSHK0235',
      swift_bic_code: null,
      bank_code: '235',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '071 United Overseas Bank Limited Hong Kong Branch',
      ts_bank_code: 'TSHK0071',
      swift_bic_code: null,
      bank_code: '071',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '067 BDO Unibank, Inc.',
      ts_bank_code: 'TSHK0067',
      swift_bic_code: null,
      bank_code: '067',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '364 Banque Pictet & Cie S.A., Hong Kong Branch',
      ts_bank_code: 'TSHK0364',
      swift_bic_code: null,
      bank_code: '364',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '393 Ant Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0393',
      swift_bic_code: null,
      bank_code: '393',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '198 Hua Nan Commercial Bank Ltd.',
      ts_bank_code: 'TSHK0198',
      swift_bic_code: null,
      bank_code: '198',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '178 KBC Bank NV, Hong Kong',
      ts_bank_code: 'TSHK0178',
      swift_bic_code: null,
      bank_code: '178',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '203 First Commercial Bank, Ltd Hong Kong Branch',
      ts_bank_code: 'TSHK0203',
      swift_bic_code: null,
      bank_code: '203',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '082 State Bank of India',
      ts_bank_code: 'TSHK0082',
      swift_bic_code: null,
      bank_code: '082',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '035 OCBC Wing Hang Bank Limited',
      ts_bank_code: 'TSHK0035',
      swift_bic_code: null,
      bank_code: '035',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '028 Public Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0028',
      swift_bic_code: null,
      bank_code: '028',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name:
        '242 Mega International Commercial Bank Co., Ltd., Hongkong Branch',
      ts_bank_code: 'TSHK0242',
      swift_bic_code: null,
      bank_code: '242',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '382 Bank of Communications (Hong Kong)Limited',
      ts_bank_code: 'TSHK0382',
      swift_bic_code: null,
      bank_code: '382',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '049 Bangkok Bank Public Company Limited Hong Kong Branch',
      ts_bank_code: 'TSHK0049',
      swift_bic_code: null,
      bank_code: '049',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '018 China CITIC Bank International Limited',
      ts_bank_code: 'TSHK0018',
      swift_bic_code: null,
      bank_code: '018',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '147 Banco Bilbao Vizcaya Argentaria, S.A., Hong Kong Branch',
      ts_bank_code: 'TSHK0147',
      swift_bic_code: null,
      bank_code: '147',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '202 The Chugoku Bank Limited Hong Kong Branch',
      ts_bank_code: 'TSHK0202',
      swift_bic_code: null,
      bank_code: '202',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '085 Toronto-Dominion Bank',
      ts_bank_code: 'TSHK0085',
      swift_bic_code: null,
      bank_code: '085',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '368 China Everbright Bank (Hong Kong Branch)',
      ts_bank_code: 'TSHK0368',
      swift_bic_code: null,
      bank_code: '368',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '070 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0070',
      swift_bic_code: null,
      bank_code: '070',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '236 Cathay United Bank Company,Limited, Hong Kong Branch',
      ts_bank_code: 'TSHK0236',
      swift_bic_code: null,
      bank_code: '236',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '324 Crédit Industriel et Commercial',
      ts_bank_code: 'TSHK0324',
      swift_bic_code: null,
      bank_code: '324',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '074 Barclays Bank plc',
      ts_bank_code: 'TSHK0074',
      swift_bic_code: null,
      bank_code: '074',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '065 Sumitomo Mitsui Banking Corporation',
      ts_bank_code: 'TSHK0065',
      swift_bic_code: null,
      bank_code: '065',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '259 Bank Of Baroda',
      ts_bank_code: 'TSHK0259',
      swift_bic_code: null,
      bank_code: '259',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '183 Coöperatieve Rabobank U.A.',
      ts_bank_code: 'TSHK0183',
      swift_bic_code: null,
      bank_code: '183',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '245 Taishin International Bank Co., Ltd Hong Kong Branch',
      ts_bank_code: 'TSHK0245',
      swift_bic_code: null,
      bank_code: '245',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '052 DBS Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0052',
      swift_bic_code: null,
      bank_code: '052',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '161 Intesa Sanpaolo SpA Hong Kong',
      ts_bank_code: 'TSHK0161',
      swift_bic_code: null,
      bank_code: '161',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '341 ICBC Standard Bank Plc',
      ts_bank_code: 'TSHK0341',
      swift_bic_code: null,
      bank_code: '341',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '308 HDFC Bank Ltd.',
      ts_bank_code: 'TSHK0308',
      swift_bic_code: null,
      bank_code: '308',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '005 Crédit Agricole CIB',
      ts_bank_code: 'TSHK0005',
      swift_bic_code: null,
      bank_code: '005',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '026 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0026',
      swift_bic_code: null,
      bank_code: '026',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '386 Hua Xia Bank Co., Limited Hong Kong Branch',
      ts_bank_code: 'TSHK0386',
      swift_bic_code: null,
      bank_code: '386',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '345 Shanghai Pudong Development Bank Hong Kong Branch',
      ts_bank_code: 'TSHK0345',
      swift_bic_code: null,
      bank_code: '345',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '180 Wells Fargo Bank, N.A., Hong Kong Branch',
      ts_bank_code: 'TSHK0180',
      swift_bic_code: null,
      bank_code: '180',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '201 Bank of Taiwan, Hong Kong Branch',
      ts_bank_code: 'TSHK0201',
      swift_bic_code: null,
      bank_code: '201',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '022 Oversea-Chinese Banking Corporation Ltd.HK Branch',
      ts_bank_code: 'TSHK0022',
      swift_bic_code: null,
      bank_code: '022',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '233 Credit Suisse AG, Hong Kong Branch',
      ts_bank_code: 'TSHK0233',
      swift_bic_code: null,
      bank_code: '233',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '277 First Abu Dhabi Bank PJSC',
      ts_bank_code: 'TSHK0277',
      swift_bic_code: null,
      bank_code: '277',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '361 China Bohai Bank Co., Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0361',
      swift_bic_code: null,
      bank_code: '361',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '344 Macquarie Bank Limited',
      ts_bank_code: 'TSHK0344',
      swift_bic_code: null,
      bank_code: '344',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '388 Livi Bank Limited',
      ts_bank_code: 'TSHK0388',
      swift_bic_code: null,
      bank_code: '388',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '066 Bank Negara Indonesia (Persero) PT.',
      ts_bank_code: 'TSHK0066',
      swift_bic_code: null,
      bank_code: '066',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '170 The Chiba Bank, Ltd. Hong Kong Branch',
      ts_bank_code: 'TSHK0170',
      swift_bic_code: null,
      bank_code: '170',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '004 The Hongkong and Shanghai Banking Corporation Limited',
      ts_bank_code: 'TSHK0004',
      swift_bic_code: null,
      bank_code: '004',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '185 DBS Bank Ltd, Hong Kong Branch',
      ts_bank_code: 'TSHK0185',
      swift_bic_code: null,
      bank_code: '185',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '113 DZ Bank Hong Kong Branch',
      ts_bank_code: 'TSHK0113',
      swift_bic_code: null,
      bank_code: '113',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '272 Bank of Singapore Limited',
      ts_bank_code: 'TSHK0272',
      swift_bic_code: null,
      bank_code: '272',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '269 The Shanghai Commercial & Savings Bank Ltd.HK Br.',
      ts_bank_code: 'TSHK0269',
      swift_bic_code: null,
      bank_code: '269',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '145 ING Bank NV',
      ts_bank_code: 'TSHK0145',
      swift_bic_code: null,
      bank_code: '145',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '307 ABN Amro Bank N.V. Hong Kong Branch',
      ts_bank_code: 'TSHK0307',
      swift_bic_code: null,
      bank_code: '307',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '275 BNP Paribas Securities Services',
      ts_bank_code: 'TSHK0275',
      swift_bic_code: null,
      bank_code: '275',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '338 Bank Of China Limited, Hong Kong Branch',
      ts_bank_code: 'TSHK0338',
      swift_bic_code: null,
      bank_code: '338',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '032 DBS Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0032',
      swift_bic_code: null,
      bank_code: '032',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '264 Land Bank of Taiwan Co., Ltd. Hong Kong',
      ts_bank_code: 'TSHK0264',
      swift_bic_code: null,
      bank_code: '264',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '265 Taiwan Cooperative Bank, Hong Kong Branch',
      ts_bank_code: 'TSHK0265',
      swift_bic_code: null,
      bank_code: '265',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '014 Bank of China (Hong Kong) Limited',
      ts_bank_code: 'TSHK0014',
      swift_bic_code: null,
      bank_code: '014',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '040 Dah Sing Bank, Limited',
      ts_bank_code: 'TSHK0040',
      swift_bic_code: null,
      bank_code: '040',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '268 Union Bank of India',
      ts_bank_code: 'TSHK0268',
      swift_bic_code: null,
      bank_code: '268',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '128 Fubon Bank (Hong Kong) Limited',
      ts_bank_code: 'TSHK0128',
      swift_bic_code: null,
      bank_code: '128',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '229 CTBC Bank Co., Ltd., Hong Kong Branch',
      ts_bank_code: 'TSHK0229',
      swift_bic_code: null,
      bank_code: '229',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '385 Ping An Bank Company Ltd.-Hong Kong Branch',
      ts_bank_code: 'TSHK0385',
      swift_bic_code: null,
      bank_code: '385',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '015 The Bank Of East Asia,Limited',
      ts_bank_code: 'TSHK0015',
      swift_bic_code: null,
      bank_code: '015',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '387 ZA Bank Limited',
      ts_bank_code: 'TSHK0387',
      swift_bic_code: null,
      bank_code: '387',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '389 Mox Bank Limited',
      ts_bank_code: 'TSHK0389',
      swift_bic_code: null,
      bank_code: '389',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '051 China CITIC Bank International Limited',
      ts_bank_code: 'TSHK0051',
      swift_bic_code: null,
      bank_code: '051',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'HK',
      bank_name: '039 Chiyu Banking Corp. Ltd.',
      ts_bank_code: 'TSHK0039',
      swift_bic_code: null,
      bank_code: '039',
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
  ],
  CN: [
    {
      bank_country: 'CN',
      bank_name: 'Yantai Bank (烟台银行)',
      ts_bank_code: 'TSCN0118',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Industrial and Commercial Bank of China (中国工商银行)',
      ts_bank_code: 'TSCN0073',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Taizhou Bank (台州银行)',
      ts_bank_code: 'TSCN0108',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Ping An Bank (平安银行)',
      ts_bank_code: 'TSCN0095',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Dezhou Bank (德州银行)',
      ts_bank_code: 'TSCN0049',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Fujian Haixia Bank (福建海峡银行)',
      ts_bank_code: 'TSCN0054',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hunan Dongkou Rural Commercial Bank (湖南洞口农村商业银行)',
      ts_bank_code: 'TSCN0132',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zhengzhou Bank (郑州银行)',
      ts_bank_code: 'TSCN0123',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Inner Mongolia Bank (内蒙古银行)',
      ts_bank_code: 'TSCN0076',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hengfeng Bank (恒丰银行)',
      ts_bank_code: 'TSCN0070',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Nanjing (南京银行)',
      ts_bank_code: 'TSCN0023',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Jining (济宁银行)',
      ts_bank_code: 'TSCN0017',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jincheng bank (晋城银行)',
      ts_bank_code: 'TSCN0083',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Guangzhou (广州银行)',
      ts_bank_code: 'TSCN0013',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Xingtai (邢台银行)',
      ts_bank_code: 'TSCN0034',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Everbright Bank (光大银行)',
      ts_bank_code: 'TSCN0042',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Mianyang City Commercial Bank (绵阳市商业银行)',
      ts_bank_code: 'TSCN0090',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Guangfa Bank (广发银行)',
      ts_bank_code: 'TSCN0057',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hana Bank (China) (韩亚银行（中国）)',
      ts_bank_code: 'TSCN0065',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Changsha (长沙银行)',
      ts_bank_code: 'TSCN0005',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Jiaxing (嘉兴银行)',
      ts_bank_code: 'TSCN0016',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Chongqing Yubei Yinzuo Rural Bank (重庆渝北银座村镇银行)',
      ts_bank_code: 'TSCN0048',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Agricultural Bank of China (中国农业银行)',
      ts_bank_code: 'TSCN0001',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jiangsu Province Rural Credit Union (江苏省农村信用社联合社)',
      ts_bank_code: 'TSCN0079',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Huishang Bank (徽商银行)',
      ts_bank_code: 'TSCN0072',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Nanchang Bank (南昌银行)',
      ts_bank_code: 'TSCN0091',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Bohai Bank (渤海银行)',
      ts_bank_code: 'TSCN0039',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Langfang (廊坊银行)',
      ts_bank_code: 'TSCN0020',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Rizhao (日照银行)',
      ts_bank_code: 'TSCN0028',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Huludao (葫芦岛银行)',
      ts_bank_code: 'TSCN0015',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jiangxi Ganzhou Rural Bank (江西赣州银座村镇银行)',
      ts_bank_code: 'TSCN0080',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Shangrao (上饶银行)',
      ts_bank_code: 'TSCN0031',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Guiyang Commercial Bank (Guiyang Bank) (贵阳市商业银行（贵阳银行）)',
      ts_bank_code: 'TSCN0063',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Ningbo Yinzhou Rural Cooperative bank (宁波鄞州农村合作银行)',
      ts_bank_code: 'TSCN0092',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Suzhou Bank (苏州银行)',
      ts_bank_code: 'TSCN0106',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Merchants Bank (招商银行)',
      ts_bank_code: 'TSCN0043',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Guizhou Rural Credit Cooperatives (贵州省农村信用社)',
      ts_bank_code: 'TSCN0128',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Shanghai Rural Commercial Bank (上海农村商业银行)',
      ts_bank_code: 'TSCN0103',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Bank of Dongguan (Dongguan Commercial Bank) (东莞银行（东莞市商业银行）)',
      ts_bank_code: 'TSCN0011',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Weihai City Commercial Bank (威海市商业银行)',
      ts_bank_code: 'TSCN0113',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Guangxi Beibu Gulf Bank (广西北部湾银行)',
      ts_bank_code: 'TSCN0060',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Chengde (承德银行)',
      ts_bank_code: 'TSCN0006',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Erdos Bank (鄂尔多斯银行)',
      ts_bank_code: 'TSCN0052',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Minsheng Bank (中国民生银行)',
      ts_bank_code: 'TSCN0044',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Longjiang Bank (龙江银行)',
      ts_bank_code: 'TSCN0088',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Linshang Bank (临商银行)',
      ts_bank_code: 'TSCN0087',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jiangnan Rural Commercial Bank (江南农村商业银行)',
      ts_bank_code: 'TSCN0133',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Shanghai (上海银行)',
      ts_bank_code: 'TSCN0029',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Citic Bank (中信银行)',
      ts_bank_code: 'TSCN0040',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Chang’an Bank (长安银行)',
      ts_bank_code: 'TSCN0038',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Communications (交通银行)',
      ts_bank_code: 'TSCN0008',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Guangzhou Rural Commercial Bank (广州农村商业银行)',
      ts_bank_code: 'TSCN0061',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Wujiang Rural Commercial Bank (吴江农村商业银行)',
      ts_bank_code: 'TSCN0115',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Shaoxing (绍兴银行)',
      ts_bank_code: 'TSCN0032',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Rural Commercial Bank of Zhangjiagang (张家港农村商业银行)',
      ts_bank_code: 'TSCN0099',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zigong Commercial Bank (自贡市商业银行)',
      ts_bank_code: 'TSCN0125',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Lanzhou Bank (兰州银行)',
      ts_bank_code: 'TSCN0086',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Ningxia Huanghe Rural Commercial Bank (宁夏黄河农村商业银行)',
      ts_bank_code: 'TSCN0093',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Fujian Province Rural Credit Union (福建省农村信用社联合社)',
      ts_bank_code: 'TSCN0055',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Shandong Province Rural Credit Union (山东省农村信用社联合社)',
      ts_bank_code: 'TSCN0101',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Jinzhou (锦州银行)',
      ts_bank_code: 'TSCN0018',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Rural Credit Union of Guangxi Zhuang Autonomous Region (广西壮族自治区农村信用社联合社)',
      ts_bank_code: 'TSCN0100',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Jilin Rural Credit Cooperative Union (吉林省农村信用社联合社)',
      ts_bank_code: 'TSCN0082',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Qilu Bank (齐鲁银行)',
      ts_bank_code: 'TSCN0097',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Hebei (河北银行)',
      ts_bank_code: 'TSCN0014',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hua Xia Bank (华夏银行)',
      ts_bank_code: 'TSCN0129',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hainan Rural Credit Union (海南省农村信用社联合社)',
      ts_bank_code: 'TSCN0064',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Kunlun (昆仑银行)',
      ts_bank_code: 'TSCN0019',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Qingdao (青岛银行)',
      ts_bank_code: 'TSCN0026',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Ningxia (宁夏银行)',
      ts_bank_code: 'TSCN0025',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Xinhan Bank (新韩银行（中国）)',
      ts_bank_code: 'TSCN0117',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Taian City Commercial Bank (泰安市商业银行)',
      ts_bank_code: 'TSCN0107',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Shanghai Pudong Development Bank (上海浦东发展银行)',
      ts_bank_code: 'TSCN0102',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Industrial Bank of Korea (企业银行（中国）)',
      ts_bank_code: 'TSCN0075',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jiangsu Bank (江苏银行)',
      ts_bank_code: 'TSCN0077',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Tianjin Rural Cooperative Bank (Tianjin Rural Credit Union, Tianjin Rural Commercial Bank) (天津农村合作银行（天津农村信用联社、天津农村商业银行）)',
      ts_bank_code: 'TSCN0110',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Zhejiang Province Rural Credit Union (浙江省农村信用社联合社)',
      ts_bank_code: 'TSCN0121',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zhejiang Sanmen Yinzuo Rural Bank (浙江三门银座村镇银行)',
      ts_bank_code: 'TSCN0122',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zhuhai China Resources Bank (珠海华润银行)',
      ts_bank_code: 'TSCN0124',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Foshan Shunde Rural Commercial Bank (佛山顺德农村商业银行)',
      ts_bank_code: 'TSCN0053',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Chongqing Rural Commercial Bank (重庆农村商业银行)',
      ts_bank_code: 'TSCN0047',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of China (中国银行)',
      ts_bank_code: 'TSCN0007',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Urumqi City Commercial Bank (乌鲁木齐市商业银行)',
      ts_bank_code: 'TSCN0111',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Shenzhen Rural Commercial Bank (深圳农村商业银行)',
      ts_bank_code: 'TSCN0105',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Qinghai (青海银行)',
      ts_bank_code: 'TSCN0027',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Weifang Bank (潍坊银行)',
      ts_bank_code: 'TSCN0112',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Xiamen Bank (厦门银行)',
      ts_bank_code: 'TSCN0116',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Laishang Bank (莱商银行)',
      ts_bank_code: 'TSCN0085',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Baoshang Bank (包商银行)',
      ts_bank_code: 'TSCN0036',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Qishang Bank (齐商银行)',
      ts_bank_code: 'TSCN0098',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Yingkou (营口银行)',
      ts_bank_code: 'TSCN0035',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Anshan City Commercial Bank (鞍山市商业银行)',
      ts_bank_code: 'TSCN0003',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Guangdong Huaxing Bank (广东华兴银行)',
      ts_bank_code: 'TSCN0058',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Liuzhou (柳州银行)',
      ts_bank_code: 'TSCN0021',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zhejiang Yiwu Rural Commercial Bank (浙江义乌农村商业银行)',
      ts_bank_code: 'TSCN0131',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Cangzhou (沧州银行)',
      ts_bank_code: 'TSCN0004',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zhejiang Chouzhou Commercial Bank (浙江稠州商业银行)',
      ts_bank_code: 'TSCN0120',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Chongqing Bank (重庆银行)',
      ts_bank_code: 'TSCN0046',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Guangdong Nanhai Rural Commercial Bank Company Limited (广东南海农村商业银行)',
      ts_bank_code: 'TSCN0127',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Harbin Bank (哈尔滨银行)',
      ts_bank_code: 'TSCN0069',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Shangqiu (商丘市商业银行)',
      ts_bank_code: 'TSCN0030',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Dalian (大连银行)',
      ts_bank_code: 'TSCN0009',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Handan Commercial Bank (邯郸市商业银行)',
      ts_bank_code: 'TSCN0066',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Panzhihua Commercial Bank (攀枝花市商业银行)',
      ts_bank_code: 'TSCN0094',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Wenzhou (温州银行)',
      ts_bank_code: 'TSCN0033',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jinshang Bank (晋商银行)',
      ts_bank_code: 'TSCN0084',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Dongying City Commercial Bank (东营市商业银行)',
      ts_bank_code: 'TSCN0051',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Luoyang (洛阳银行)',
      ts_bank_code: 'TSCN0022',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jilin Bank (吉林银行)',
      ts_bank_code: 'TSCN0081',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Construction Bank (中国建设银行)',
      ts_bank_code: 'TSCN0041',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hankou Bank (汉口银行)',
      ts_bank_code: 'TSCN0068',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Beijing (北京银行)',
      ts_bank_code: 'TSCN0126',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Industrial Bank Co., Ltd. (兴业银行)',
      ts_bank_code: 'TSCN0074',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Bank of Deyang (Great Wall Western China Bank) (德阳银行(长城华西银行）)',
      ts_bank_code: 'TSCN0010',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Hubei Province Rural Credit Union (湖北省农村信用社联合社)',
      ts_bank_code: 'TSCN0071',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Shenzhen Futian Yinzuo Rural Bank (深圳福田银座村镇银行)',
      ts_bank_code: 'TSCN0104',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Woori Bank (友利银行(中国))',
      ts_bank_code: 'TSCN0114',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Beijing Shunyi Yinzuo Rural Bank (北京顺义银座村镇银行)',
      ts_bank_code: 'TSCN0037',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Zhangjiakou Commercial bank (张家口市商业银行)',
      ts_bank_code: 'TSCN0119',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Ganzhou Bank (赣州银行)',
      ts_bank_code: 'TSCN0056',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Tianjin Bank (天津银行)',
      ts_bank_code: 'TSCN0109',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Jieshou Rural Commercial Bank (界首农村商业银行)',
      ts_bank_code: 'TSCN0130',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'China Zheshang Bank (浙商银行)',
      ts_bank_code: 'TSCN0045',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Hangzhou Bank (Hangzhou Commercial Bank) (杭州银行（杭州市商业银行）)',
      ts_bank_code: 'TSCN0067',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Postal Savings Bank of China (中国邮政储蓄银行)',
      ts_bank_code: 'TSCN0096',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name:
        'Jiangsu Changshu Rural Commercial Bank (江苏常熟农村商业银行)',
      ts_bank_code: 'TSCN0078',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Fuxin (阜新银行)',
      ts_bank_code: 'TSCN0012',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Anhui Province Rural Credit Union (安徽省农村信用联社)',
      ts_bank_code: 'TSCN0002',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Dongguan Rural Commercial Bank [DRC Bank] (东莞农村商业银行)',
      ts_bank_code: 'TSCN0050',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Bank of Ningbo (宁波银行)',
      ts_bank_code: 'TSCN0024',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Guangdong Nanyue Bank (广东南粤银行)',
      ts_bank_code: 'TSCN0059',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Guilin Bank (桂林银行)',
      ts_bank_code: 'TSCN0062',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
    {
      bank_country: 'CN',
      bank_name: 'Luohe City Commercial Bank (漯河市商业银行)',
      ts_bank_code: 'TSCN0089',
      swift_bic_code: null,
      bank_code: null,
      zengin_code: null,
      cnaps_code: null,
      ifsc_code: null,
    },
  ],
};

export const getBankDestinationOptions = (countryCode: string) => {
  let bankDestinationOptions: {
    label: string;
    value: string;
    ts_bank_code: string;
    swift_bic_code: string | null;
  }[] = [];

  LIST_BANK_DESTINATION[countryCode].map(bank => {
    if (bank.bank_country === countryCode) {
      bankDestinationOptions.push({
        label: bank.bank_name,
        value: bank.bank_name,
        ts_bank_code: bank.ts_bank_code,
        swift_bic_code: bank.swift_bic_code,
      });
    }
  });

  return bankDestinationOptions;
};

export enum CreateTransferStatus {
  FAILED,
  SUCCESS,
  WAITING_APPROVAL,
  CANCELLED,
  IN_PROGRESS,
}
